import type { ReactNode } from 'react';

export const symbol_perm_media: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M100-120q-24.75 0-42.37-17.63Q40-155.25 40-180v-530q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v530h710q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H100Zm120-120q-24.75 0-42.37-17.63Q160-275.25 160-300v-520q0-24.75 17.63-42.38Q195.25-880 220-880h215q12.44 0 23.72 5T478-862l62 62h320q24.75 0 42.38 17.62Q920-764.75 920-740v440q0 24.75-17.62 42.37Q884.75-240 860-240H220Zm0-60h640v-440H515l-80-80H220v520Zm0 0v-520 520Zm284-150-62-73q-5-5-11.5-4.5T419-522l-65 77q-6 8-1.87 16.5 4.12 8.5 13.87 8.5h350q9.21 0 13.1-8 3.9-8-1.1-16L626-580q-5-6-12-6t-12 6l-98 130Z"
		/>
	</svg>
);
